import { useQuery } from "@tanstack/react-query";
import { QueryModule } from "@/data/queryModules";
import { AppQueryOptions } from "@povio/openapi-codegen-cli";
import { LoyaltyApi } from "./loyalty.api";

export namespace LoyaltyQueries {

export const moduleName = QueryModule.Loyalty;

export const keys = {
    all: [moduleName] as const,
    listRewards: () => [...keys.all, "/loyalty/rewards", ] as const,
    getPoints: () => [...keys.all, "/loyalty/points", ] as const,
};


 /** 
 * Query `useListRewards`
 * @summary List all rewards with user status
 * @param { AppQueryOptions } options Query options
 * @returns { UseQueryResult<LoyaltyModels.ListRewardsResponse> } List of rewards with unlock and redemption status for current user
 * @statusCodes [200, 401]
 */
export const useListRewards = <TData>(options?: AppQueryOptions<typeof LoyaltyApi.listRewards, TData>) => {
  
  
  return useQuery({
    queryKey: keys.listRewards(),
    queryFn: LoyaltyApi.listRewards
    ,
    ...options,
  });
};






 /** 
 * Query `useGetPoints`
 * @summary Get user points summary
 * @param { AppQueryOptions } options Query options
 * @returns { UseQueryResult<LoyaltyModels.PointsSummary> } User points balance and statistics
 * @statusCodes [200, 401]
 */
export const useGetPoints = <TData>(options?: AppQueryOptions<typeof LoyaltyApi.getPoints, TData>) => {
  
  
  return useQuery({
    queryKey: keys.getPoints(),
    queryFn: LoyaltyApi.getPoints
    ,
    ...options,
  });
};






}
